import { render, staticRenderFns } from "./amList.vue?vue&type=template&id=2f236367&scoped=true&"
import script from "./amList.vue?vue&type=script&lang=js&"
export * from "./amList.vue?vue&type=script&lang=js&"
import style0 from "./amList.vue?vue&type=style&index=0&id=2f236367&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f236367",
  null
  
)

export default component.exports